import React from 'react';
import { Link } from 'react-router-dom';
import { Game } from '../../types';
import { ChevronRight } from 'lucide-react';

export const GameCard: React.FC<{ game: Game }> = ({ game }) => {
  return (
    <Link
      to={`/games/${game.slug}`}
      className="group relative rounded-2xl overflow-hidden bg-white dark:bg-brand-darkCard border border-brand-lightBorder dark:border-brand-darkBorder hover:border-brand-blue/60 dark:hover:border-brand-accent/60 shadow-sm hover:shadow-glow-blue transition-all duration-300 flex flex-col"
    >
      <div className="relative aspect-[4/3] w-full overflow-hidden bg-slate-900">
        <img
          src={game.banner_url || game.icon_url}
          alt={game.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
        
        {/* Game icon logo avatar */}
        <div className="absolute bottom-3 left-3 flex items-center gap-3">
          <img
            src={game.icon_url}
            alt=""
            className="w-10 h-10 rounded-xl object-cover border-2 border-white/40 shadow-md"
          />
          <div>
            <h4 className="font-extrabold text-sm text-white group-hover:text-brand-accent transition-colors drop-shadow">
              {game.name}
            </h4>
            <p className="text-[11px] text-white/70">{game.publisher}</p>
          </div>
        </div>
      </div>

      <div className="p-3 bg-brand-lightSec dark:bg-brand-darkElevated/50 flex items-center justify-between text-xs text-brand-lightSecText dark:text-brand-darkSecText">
        <span>{game.active_listings_count || 12}+ Active Offers</span>
        <span className="font-semibold text-brand-blue dark:text-brand-accent flex items-center gap-0.5 group-hover:translate-x-1 transition-transform">
          Explore <ChevronRight className="w-3.5 h-3.5" />
        </span>
      </div>
    </Link>
  );
};
